import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { AssignMailComponent } from '../../../../views/university-communications/shared/assign-mail/assign-mail.component';
import { CamsIdSearchComponent } from '../../../../views/university-communications/shared/cams-id-search/cams-id-search.component';
import { ReferURMComponent } from '../../../../views/university-communications/shared/refer-urm/refer-urm.component';
import { SelectionWarningComponent } from '../../../../views/university-communications/shared/selection-warning/selection-warning.component';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ApplicationMasterService } from 'src/app/core/services/applicationMaster/application-master.service';
import { MatTableDataSource } from '@angular/material/table';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { EmailActivityType } from 'src/app/core/constants/dropdown-contants';
import { permissionEntity } from 'src/app/core/constants/permission';

@Component({
  selector: 'app-email-activity',
  templateUrl: './email-activity.component.html',
  styleUrls: ['./email-activity.component.scss']
})
export class EmailActivityComponent implements OnInit, OnChanges, OnDestroy {
  @Input() type: string;
  @Input() selected_mails: string;
  @Output() trigger_reload_data: EventEmitter<any> = new EventEmitter();
  displayedColumns: string[] = [
    'camsID', 
    'store',
    'studentName',
    'courseName',
    'universityName',
    'primaryStatus',
    'secondaryStatus'
  ];
  dataSource = new MatTableDataSource<any>();
  show_app_table: boolean = false;
  login_user_details: any;
  email_activity_type = EmailActivityType;
  
  private _unsubscribeAll: Subject<any> = new Subject();
  permissions_entity = permissionEntity;
  
  constructor(
    public dialog: MatDialog,
    public themeService: CustomizerSettingsService,
    private _loaderService: LoaderService,
    private _appMasterService: ApplicationMasterService,
    private _universityCommunicationService: UniversityCommunicationService,
    private _toasterService: ToasterService,
    private _authService: AuthenticationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.selected_mails = changes['selected_mails'].currentValue;
  }

  ngOnInit(): void {
    this.login_user_details = this._authService.getLoginUserDetails();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }

  openAssignPopup() {
    const dialogRef = this.dialog.open(AssignMailComponent, {
      width: '100%',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      data: {
        selected_mails: this.selected_mails,
        showAssignDone: true
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.trigger_reload_data.emit(true);
        }
    });
  }

  openCAMSSearchPopup() {
    const dialogRef = this.dialog.open(CamsIdSearchComponent, {
      width: '40%',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getApplications(result);
        }
    });
  }

  referToManagement() {
    if (!this.selected_mails?.length) {
      this._universityCommunicationService.openWarningPopup('');
      return;
    }
    let payload = `messageId=${this.selected_mails}&type=${this.email_activity_type.management.id}&userId=${this.login_user_details.id}`;
    this.bulkUpdate(this.email_activity_type.management.value, payload);
  }

  sendToImportant() {
    if (!this.selected_mails?.length) {
      this._universityCommunicationService.openWarningPopup('');
      return;
    }
    let payload = `messageId=${this.selected_mails}&type=${this.email_activity_type.important.id}&userId=${this.login_user_details.id}`;
    this.bulkUpdate(this.email_activity_type.important.value, payload);
  }

  sendToDone() {
    if (!this.selected_mails?.length) {
      this._universityCommunicationService.openWarningPopup('');
      return;
    }
    let payload = `messageId=${this.selected_mails}&type=${this.email_activity_type.done.id}&userId=${this.login_user_details.id}`;
    this.bulkUpdate(this.email_activity_type.done.value, payload);
  }

  moveToJunk() {
    if (!this.selected_mails?.length) {
      this._universityCommunicationService.openWarningPopup('');
      return;
    }
    let payload = `messageId=${this.selected_mails}&type=${this.email_activity_type.junk.id}&userId=${this.login_user_details.id}`;
    this.bulkUpdate(this.email_activity_type.junk.value, payload);
  }

  openReferURMPopup() {
    const dialogRef = this.dialog.open(ReferURMComponent, {
      width: '40%',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      data: {
        selected_mails: this.selected_mails
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.trigger_reload_data.emit(true);
        }
    });
  }

  getApplications(filter: any) {
    this._loaderService.showLoader();
    this._appMasterService.getApplication({skip: 0, limit: 10}, filter)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(result => {
      if (result) {
        const data = this.getCovertedArray(
          result?.data?.data || []
        );
        this.dataSource = new MatTableDataSource(data);
        this.show_app_table = true;
        this._loaderService.hideLoader();
      }
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  private getCovertedArray(data: any): any[] {
    const converted = data.map((item: any) => {
        return {
            id: item?.id,
            store: item?.tenantName,
            name: `${item?.studentPersonalDetailsRef?.firstName} ${item?.studentPersonalDetailsRef?.lastName}`,
            student: item?.studentPersonalDetailsRef,
            coursesDetails: item?.coursesDetails,
            coursesEnrolement: item?.coursesEnrolementRef,
            universityDetails: item?.universityDetails,
            primaryStatus: item?.currentStatus?.primaryStatus,
            secondaryStatus: item?.currentStatus?.secondaryStatus,
        };
    });
    return converted;
  }

  bulkUpdate(type: string, payload: any) {
    this._loaderService.showLoader();
    this._universityCommunicationService.bulkUpdate(payload)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(res => {
      this.trigger_reload_data.emit(true);
      let msg = '';
      if (type === this.email_activity_type.management.value) {
        msg = 'Refer to management';
      }
      if (type === this.email_activity_type.important.value) {
        msg = 'Send to important';
      }
      if (type === this.email_activity_type.done.value) {
        msg = 'Send to done';
      }
      if (type === this.email_activity_type.junk.value) {
        msg = 'Move to junk';
      }
      this._toasterService.showSuccess('SUCCESS', `${msg} successfully`);
      this._loaderService.hideLoader();
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
